import { Page } from '@/components';
import TokensArbitrumTable from './TokensArbitrumTable';
export default function ArbitrumTokenPage() {
  return (
    <Page title="Tokens">
      <TokensArbitrumTable />
    </Page>
  );
}
